module.exports = __webpack_public_path__ + "static/img/product_banner.f43e86f7.png";